// extracted by mini-css-extract-plugin
module.exports = {"swiper-preloader-spin":"swiper-preloader-spin___39L9X"};